<template>
  <b-card
    title="مدیریت پرسش و پاسخ"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
          <div class="filter-row">
            <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                :to="{name:'addDedicatedDietQuestion'}"
            >
              جدید
            </b-button>
            <b-col md="2">
              <b-form-group
                  label="عنوان"
                  label-for="Title"
              >
                <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group>
                <label>وضعیت</label>
                <v-select
                    v-model="filterOptions.IsActive"
                    :options="enums('IsActive')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                />
              </b-form-group>
            </b-col>
            <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
            >فیلتر
            </b-button>
          </div>
        </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2"
          responsive
          :busy="loading"
          :no-local-sorting="true"
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              :to="{name:'addDedicatedDietQuestion',params:{QuestionID:data.item.Id}}"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Type)="data">
              {{ enums('questionType','value',data.value,'text') }}
          </template>

          <template #cell(IsRequired)="data">
            <b-badge
                :variant="data.value ? 'light-danger' : 'light-info'"
            >
              {{ data.value ? 'اجباری' : 'اختیاری' }}
            </b-badge>
          </template>

          <template #cell(IsActive)="data">
            <b-badge
                :variant="enums('IsActive', 'value', data.value, 'badge')"
            >
              {{ enums('IsActive', 'value', data.value, 'text') }}
            </b-badge>
          </template>

          <template #cell(actions)="data">
            <div
              class="text-nowrap"
            >
              <b-link
                  :to="{name:'addDedicatedDietQuestion',params:{QuestionID:data.item.Id}}"
              >
                <feather-icon
                    icon="EditIcon"
                    size="16"
                />
              </b-link>
              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>
        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>
  </b-card>

</template>

<script>
export default {
  name: 'DedicatedDietQuestion',
  data() {
    return {
      loading: false,
      filterOptions: {
        Page: 1,
        Title: null,
        PerPage: 10,
        SortBy: 'Id',
        IsDesc: true,
      },
      totalRows: null,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Type',
          label: 'نوع',
        },
        {
          key: 'IsRequired',
          label: 'الزام پاسخگویی',
        },
        {
          key: 'Sort',
          label: 'الویت',
          sortable: true,
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        if (this.filterOptions.SortBy === 'Sort') {
          this.filterOptions.SortBy = 'Priority'
        }
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })
      this.$http.post(this.$api.question.getlist, this.filterOptions).then(res => {
        this.items = res.data
        this.totalRows = res.totalRow
      }).finally(() => {
        this.loading = false
      })
    },
    showEditModal(item) {
      this.showModal = true
      this.editCalorie = true
      this.form = { ...item }
    },
    remove(id) {
      this.removeRow(this.$api.question.remove, 'Id', id)
    },
    closeModal() {
      this.showModal = false
      this.editCalorie = false
      Object.keys(this.form).forEach(key => { this.form[key] = null })
    },
  },
}
</script>

<style scoped>

</style>
